import * as tslib_1 from "tslib";
import { Exclude, Type } from 'class-transformer';
import { KeyValueResultDto } from './key-value-result-dto';
import { Utils } from 'cc-common';
const ɵ0 = () => KeyValueResultDto, ɵ1 = () => Date;
export class PropertyCommunityInfoResultDto {
    constructor() {
        this.isTerminating = Utils.notNullAndDefined(this.communityTerminatingDate);
    }
    get communityTerminatingDate() {
        return this.terminatingDate;
    }
    // Transient fields
    get context() {
        if (!!this.communityId) {
            return `C${this.communityId}`;
        }
        else if (!!this.locationId) {
            return `L${this.locationId}`;
        }
        return `M${this.managementCompanyId}`;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], PropertyCommunityInfoResultDto.prototype, "propertyCommunities", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], PropertyCommunityInfoResultDto.prototype, "terminatingDate", void 0);
tslib_1.__decorate([
    Exclude(),
    tslib_1.__metadata("design:type", Object)
], PropertyCommunityInfoResultDto.prototype, "isTerminating", void 0);
export { ɵ0, ɵ1 };
